import { ProductionType } from '../../../../../services/analysis.service';
import { ToolProductionType } from './tool-production-type';

export class PvsysProductionType extends ToolProductionType {
  getProductionType(): ProductionType {
    return ProductionType.PVSYS;
  }

}
